// computed 에서만 사용되는 것.

import {ClaimClassType, ClaimStatusType, ClaimType} from '@/types/claim';

export function isCancelClaim(): boolean{
  return this.claimType === ClaimType.CANCEL
}

export function isExchangeClaim(): boolean{
  return this.claimType === ClaimType.EXCHANGE
}

export function isReturnClaim(): boolean{
  return this.claimType === ClaimType.RETURN
}

export function isCancelProcRequestRefund(): boolean {
  return this.claimStatusType === ClaimStatusType.CANCEL_PROC_REQUEST_REFUND;
}

export function isCancelRequest(): boolean {
  return this.claimStatusType === ClaimStatusType.CANCEL_REQUEST;
}

export function isCancelProcWaitingRefund(): boolean {
  return this.claimStatusType === ClaimStatusType.CANCEL_PROC_WAITING_REFUND;
}

export function isCancelNoRefund(): boolean{
  return this.claimStatusType === ClaimStatusType.CANCEL_NO_REFUND
}

export function isCancelDone(): boolean{
  return this.claimStatusType === ClaimStatusType.CANCEL_DONE
}

export function isReturnDone(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_DONE
}

export function isExchangeRequest(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_REQUEST
}

export function isExchangeProcBeforeReceive(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_PROC_BEFORE_RECEIVE
}

export function isExchangeProcRequestRefund(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_PROC_REQUEST_REFUND
}

export function isExchangeProcRequestPay(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_PROC_REQUEST_PAY
}

export function isExchangeProcWaitingPay(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_PROC_WAITING_PAY
}

export function isExchangeDonePayDone(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_DONE_PAY_DONE
}

export function isExchangeRejectRequest(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_REJECT_REQUEST
}

export function isExchangeProcWaiting(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_PROC_WAITING
}

export function isExchangeProcWaitingRefund(): boolean{
  return this.claimStatusType === ClaimStatusType.EXCHANGE_PROC_WAITING_REFUND
}

export function isReturnRequest(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_REQUEST
}

export function isReturnProcRequestRefund(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_PROC_REQUEST_REFUND
}

export function isReturnRefundAmtAdjustRequested(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_REFUND_AMT_ADJUST_REQUESTED
}

export function isReturnProcWaitingRefund(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_PROC_WAITING_REFUND
}

export function isReturnProcRequestReceive(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_PROC_BEFORE_RECEIVE
}

export function isReturnRejectRequest(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_REJECT_REQUEST
}

export function isReturnProcBeforeReceive(): boolean{
  return this.claimStatusType === ClaimStatusType.RETURN_PROC_BEFORE_RECEIVE
}

export function isOrderCancel(): boolean{
  return this.claimNoResponseData.claimClassType === ClaimClassType.ORDER_CANCEL
}

export function isOptionCancel(): boolean{
  return this.claimNoResponseData.claimClassType === ClaimClassType.OPTION_CANCEL
}

export function isCancelExchange(): boolean{
  return this.claimNoResponseData.claimClassType === ClaimClassType.CANCEL_EXCHANGE
}

export function isReturnExchange(): boolean{
  return this.claimNoResponseData.claimClassType === ClaimClassType.RETURN_EXCHANGE
}

// 클레임 처리 완료
export const isDoneClaim = (claimStatusType: ClaimStatusType): boolean => {
  const doneClaimStatus = ['CANCEL_DONE', 'RETURN_DONE', 'EXCHANGE_DONE_PAY_DONE', 'EXCHANGE_DONE_REFUND_DONE', 'EXCHANGE_DONE', 'CANCEL_NO_REFUND'];
  return doneClaimStatus.includes(claimStatusType.toString())
}

